module.exports = __webpack_public_path__ + "img/H000020_mushroom.2f478965.png";